<template >
  <section id="privacy">
    <div id="main" style="padding-top: 0px;">
      
      <!-- <div class="privacy-nav">
        <div class="container-my-help">
          <article class="container-my-help-article container-my-help-article-nav">
            <router-link to="/privacypolicy" @click.native="on('/privacypolicy')">{{$t('pp.nav')[0]}}</router-link>
            <router-link to="/dataprotectionnotice" @click.native="on('/dataprotectionnotice')">{{$t('pp.nav')[1]}}</router-link>
          </article>
        </div>
      </div> -->
      <div class="container-my-help">
        <article class="container-my-help-article">
          <h2 class="b">{{$t('pp.title1')}}</h2>
          <div class="mp-2"></div>
          <h2 class="b">{{$t('pp.title2')}}</h2>
          <div class="mp-2"></div>
          <h2>{{$t('pp.tt1')}}</h2>
          <div class="subtitle" v-html="$t('pp.p1_1')"></div>

          <div>
            <h2>{{$t('pp.tt2')}}</h2>
            <div class="subtitle" v-html="$t('pp.p2_1')"></div>
            <div class="content-list" v-html="$t('pp.list2')"></div>
            <div class="subtitle" v-html="$t('pp.p2_2')"></div>

            <h2>{{$t('pp.tt3')}}</h2>
            <div class="subtitle" v-html="$t('pp.p3_1')"></div>
            <div class="content-list" v-html="$t('pp.list3')"></div>
            <div class="subtitle" v-html="$t('pp.p3_2')"></div>

            <h2>{{$t('pp.tt4')}}</h2>
            <div class="subtitle" v-html="$t('pp.p4_1')"></div>

            <h2>{{$t('pp.tt5')}}</h2>
            <div class="subtitle" v-html="$t('pp.p5_1')"></div>
            <div class="content-list" v-html="$t('pp.list5')"></div>
            <div class="subtitle" v-html="$t('pp.p5_2')"></div>

            <h2>{{$t('pp.tt6')}}</h2>
            <div class="subtitle" v-html="$t('pp.p6_1')"></div>
            <div class="content-list" v-html="$t('pp.list6')"></div>
            <div class="subtitle" v-html="$t('pp.p6_2')"></div>

            <h2>{{$t('pp.tt7')}}</h2>
            <div class="subtitle" v-html="$t('pp.p7_1')"></div>
            <div class="content-list" v-html="$t('pp.list7')"></div>
            <div class="subtitle" v-html="$t('pp.p7_2')"></div>
            <div class="content-list" v-html="$t('pp.list7_2')"></div>
            <div class="subtitle" v-html="$t('pp.p7_3')"></div>

            <h2>{{$t('pp.tt8')}}</h2>
            <div class="subtitle" v-html="$t('pp.p8_1')"></div>

            <h2>{{$t('pp.tt9')}}</h2>
            <div class="subtitle" v-html="$t('pp.p9_1')"></div>

            <h2>{{$t('pp.tt10')}}</h2>
            <div class="subtitle" v-html="$t('pp.p10_1')"></div>

            <h2>{{$t('pp.tt11')}}</h2>
            <div class="subtitle" v-html="$t('pp.p11_1')"></div>

            <h2>{{$t('pp.tt12')}}</h2>
            <div class="subtitle" v-html="$t('pp.p12_1')"></div>
            <div class="subtitle" v-html="$t('pp.list12')"></div>
            
            <h2>{{$t('pp.tt13')}}</h2>
            <div class="subtitle" v-html="$t('pp.p13_1')"></div>

            <h2>{{$t('pp.tt14')}}</h2>
            <div class="subtitle" v-html="$t('pp.p14_1')"></div>

            <h2>{{$t('pp.tt15')}}</h2>
            <div class="subtitle" v-html="$t('pp.p15_1')"></div>
            <div class="subtitle" v-html="$t('pp.p15_2')"></div>
            
          </div>
        </article>
      </div>
    </div>
    <div class="scollTop" id="imgscoll" v-if="tops" @click="goTop()">
      <svg t="1611198729695" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2557" width="28" height="28"><path d="M64.271816 746.039337 511.185448 247.433392 959.727161 746.039337 928.793638 776.566608 511.185448 312.150346 95.206362 776.566608Z" p-id="2558" fill="#ffffff"></path></svg>
    </div>

    <!-- <van-popup class="van-popup2" closeable close-icon="close" v-model="showpdf"><PDF :value="pdfdow" /></van-popup> -->
  </section>
</template>

<script>

import { Toast,Button,Popup } from 'vant'
// import PDF from '../../untils/pdf/pdf.vue';
export default {
  name: "privacyPolicy",
  inject: ['reload'],
  data() {
    return {
      pdfdow: {title: '', text: '', dow: 'https://approvedplus.hk-audi.com/file/Datenschutzhinweis_Werkstattaufenthalt_EN_102020.pdf', img: '', model: ''},
      show: false,
      showpdf: false,
      tops: false,
      // heights: '',
      scrolltop: '',
    };
  },
  components: {
    // PDF
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop)
    
    PubSub.subscribe('locale', (msg, data) => {
			if (data.locale != '') {
      	this.reload()
				this.$validator.locale = this.$store.state.locale
			}
		})
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    goTop() {
      // 回到顶部
      let timer = setInterval(() => {
          document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
          if (this.scrolltop === 0) {
              clearInterval(timer)
          }
      }, 10)
    },
    scrollToTop(e) {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.scrolltop = scrollTop
      if (parseInt(this.scrolltop) > 300) {
          this.tops = true
      } else {
          this.tops = false
      }
    },
    on(url) {
      // 发布消息
      PubSub.publish('on', {url: url, on: 'on'})
    },
    showPopupPdf() {
      this.showpdf = true
    }
  },
};
</script>

<style lang="stylus" ref="stylesheet/stylus" scoped>
  #privacy {
    counter-reset: num;
    font-size: 14px;
    line-height: 26px;
    .privacy-nav {
      // padding: 0 0 0 10%;
      margin-bottom: 70px;
      background: #000;
      overflow: hidden;
      a {
        padding: 16px 16px;
        display: block;
        float: left;
        color: #fff;
        cursor: pointer;
        &:first-of-type {
          text-decoration: underline;
        }
        &:last-of-type {
          &:hover {
            text-decoration: none;
          }
        }
      }
    }
    h2 {
      margin: 18px 0 6px;
      font-family: 'OpenSans';
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 0.44px;
      line-height: 30px;
      text-decoration: underline;
    }
    .subtitle {
      margin-bottom: 18px;
    } 
    // .content {
    //   line-height: 22px;
    //   margin-bottom: 38px;
    // }
    .content-list {  
      margin-bottom: 42px;
      padding-left: 4%;
      padding-right: 4%;
      ul {
        li {
          margin-top: 6px;
          line-height: 24px;
          .iconfont {    
            font-size: 17px;
            font-weight: 400;
            margin-right: 12px;
          }
        }
      }
    }
    
    .scollTop {
      padding: 8px;
      position: fixed;
      bottom: 2rem;
      right: 0;
      background: #000;
      cursor: pointer;
    }
  }
  

  @media (max-width: 520px) {
    #privacy {
      .privacy-nav {
        a {
          padding: 10px 10px;
          font-size: 14px;
        }
      }
    }
  }

  @media (max-width: 410px) {
    #privacy {
      .privacy-nav {
        a {    
          padding: 12px 8px;
          font-size: 13px;
        }
      }
    }
  }

  @media (max-width: 377px) {
    .container-my-help-article-nav {
      margin-left: 2%;
      margin-right: 0%;
    }
    #privacy {
      .privacy-nav {
        a {
          padding: 12px 6px;
          font-size: 12px;
        }
      }
    }
  }
  @media (min-width: 768px) {
    #privacy {
      font-size: 15px;
      h2 {
        margin: 32px 0 6px;
        font-size: 21px;
      }
    }
  }

  @media (min-width: 1440px) {
    #privacy {
      font-size: 17px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/help/PrivacyPolicy.vue